$(window).on('load', function() {
    var owlItemView = $('.item-view-carousel');
    owlItemView.owlCarousel({
        items: 2,
        lazyLoad: true,
        nav:true,
        navText: ['',''],
        rewind: true,
        video:true,
        URLhashListener:true,
        onInitialized: function (event) {
            $('.item-view-carousel-num').find('span').html((event.item.index+1)+'/'+(event.item.count-1));
        }
    });

    owlItemView.on('changed.owl.carousel', function(event) {
        $('.item-view-carousel-num').find('span').html((event.item.index+1)+'/'+(event.item.count-1));
        if ( $('.carousel-box').is( ".rsFullscreen" ) ) {
            setTimeout(function (e) {
                $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': 'initial', 'min-width': 'initial'});
                $('.item-view-carousel.owl-carousel .owl-item.active').css({'max-width': $(window).width(), 'min-width': $(window).width()});
            }, 100)
        } else if ($(window).width()<=576){
            setTimeout(function (e) {
                $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': 'initial', 'min-width': 'initial'});
                $('.item-view-carousel.owl-carousel .owl-item.active').css({'max-width': owlItemView.width(), 'min-width': owlItemView.width()});
            }, 100)
        } else {
            $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': '', 'min-width': ''});
        }
    });

    owlItemView.on('translate.owl.carousel',function(e){
        $('.owl-item video').each(function(){
            $(this).get(0).pause();
        });
    });
    owlItemView.on('translated.owl.carousel',function(e){
        if($('.owl-item.active').eq(0).find('video').length){
            $('.owl-item.active').eq(0).find('video').get(0).play();
            $('.item-view-carousel-video').hide();
            $('.item-image-fullscreen').hide();
        } else {
            $('.item-view-carousel-video').show();
            $('.item-image-fullscreen').show();
        }

    });



    $('.item-view-carousel-video a').click(function() {
        var index = $('.video_firs_item').parent('.owl-item').index();
        if(index/2 % 2 !==0){
            owlItemView.trigger('to.owl.carousel', [((index-1)/2)]);
            owlItemView.trigger('next.owl.carousel');
        } else {
            owlItemView.trigger('to.owl.carousel', [(index/2)]);
        }
    });
    /*var slickSlider = $('.fullscreen-slider').slick({
        slidesToShow: 1,
        arrows: false
    });*/

    $('.item-image-fullscreen, .close-fullscreen').on('click', function (e) {
        $('.carousel-box').toggleClass( "rsFullscreen" );
        owlItemView.trigger('refresh.owl.carousel');
        $('body').toggleClass( "fullscreen-view" );
        if ( $('.carousel-box').is( ".rsFullscreen" ) ) {
           //slickSlider.slick('setPosition');
           $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': 'initial', 'min-width': 'initial'});
           $('.item-view-carousel.owl-carousel .owl-item.active').css({'max-width': $(window).width(), 'min-width': $(window).width()});
        } else if ($(window).width()<=576){
           $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': 'initial', 'min-width': 'initial'});
           $('.item-view-carousel.owl-carousel .owl-item.active').css({'max-width': owlItemView.width(), 'min-width': owlItemView.width()});
        } else {
           $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': '', 'min-width': ''});
        }
    });

    /*$('.owl-next').click(function() {
        owlItemView.trigger('next.owl.carousel');
        slickSlider.slick('slickNext');
    });
    $('.owl-prev').click(function() {
        owlItemView.trigger('prev.owl.carousel');
        slickSlider.slick('slickPrev');
    });*/


   if($(window).width()<=576){
       $('.item-view-carousel.owl-carousel .owl-item').css({'max-width': 'initial', 'min-width': 'initial'});
       $('.item-view-carousel.owl-carousel .owl-item.active').css({'max-width': $('.item-view-carousel').width(), 'min-width': $('.item-view-carousel').width()});
   }

    ymapsInit();
    $(document).on('click', '.item-street-view-btn:not(.active)', function (e) {
        e.preventDefault();
        $(this).addClass('active');
        ymapsPanorama();
    });
});

function sendItemYorFriend($this, event, items, currency) {
    event.preventDefault();
    var $thisForm = $($this);
    var isValidForm = true;
    var data = {
        email: $thisForm.find('#send_email').val(),
        your_email: $thisForm.find('#your_email').val(),
        items: items,
        currency: currency || 1
    };

    loadingShowHideInBtn($thisForm.find('.btn-loader')).show();

    $thisForm.find('.form-control').each(function ($index) {
        if($(this).is(":invalid")){
            isValidForm = false;
            return false;
        }
    });


    if(isValidForm){
        $.ajax({
            type: "POST",
            url: window.location.origin + "/api/send_favorites.php",
            data: data
        }).then(function(response){
            if(response === 'success'){
                $thisForm[0].reset();

                alertNotification(MESSAGES.THE_STATEMENT_ADDED[language]).success();

                $('#sendItemModal').modal('hide');
            } if(response === 'error_mail'){
                alertNotification('error_mail').error();
            } else {
                modalNotification(response).error();
            }
        }).done(function(result){
            loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        }).fail(function(result){
            loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        });
        $this.classList.remove('was-validated');
    } else {
        loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        $this.classList.add('was-validated');
    }



}

function sendRequestForm($this, event, type) {
    event.preventDefault();
    var $thisForm = $($this);
    var isValidForm = true;
    var data = {
        type: type,
        item_id: $thisForm.find('.send_request_item_id').val() || null,
        name: $thisForm.find('.send_request_name').val(),
        email: $thisForm.find('.send_request_email').val(),
        phone: $thisForm.find('.send_request_phone').val(),
        message: $thisForm.find('.send_request_message').val() ? $thisForm.find('.send_request_message').val() : $thisForm.find('.send_request_message').attr('placeholder')
    };



    loadingShowHideInBtn($thisForm.find('.btn-loader')).show();

    $thisForm.find('.form-control').each(function ($index) {
        if($(this).is(":invalid")){
            isValidForm = false;
            return false;
        }
    });


    if(isValidForm){
        $.ajax({
            type: "POST",
            url: window.location.origin + "/api/sendrequest.php",
            data: data
        }).then(function(response){
            if(response === 'success'){
                ym(94039732,'reachGoal',' listing-submit')
                $thisForm[0].reset();
                alertNotification(MESSAGES.SUCCESS.AFTER_REQUEST[language]).success();

                $('#sendRequest').modal('hide');
            } else {
                modalNotification(response).error();
            }
        }).done(function(result){
            loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        }).fail(function(result){
            $thisForm.removeClass('was-validated');
            loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        });
        $this.classList.remove('was-validated');
    } else {
        /*$thisForm.find('.form-control:invalid').on('change', function () {
            var body = $('body');
            if(body.find('.alert').length){
                body.find('.alert').remove();
            }
        });
        alertNotification(MESSAGES.ERROR.FILLING_FIELDS[language]).error();*/
        loadingShowHideInBtn($thisForm.find('.btn-loader')).hide();
        $this.classList.add('was-validated');
    }
}

function ymapsInit() {
    if($('#yandex_map_item_view').length){
        ymaps.ready(ymapsPanorama);
    }
}
var  myMap, myMapPanorama;
function initYandexMap(){
    if(myMapPanorama){
        myMapPanorama.destroy();
        myMapPanorama = null;
    }
    if(myMap){
        myMap.destroy();
        myMap = null;
    }

    var yandexMapItemView = $('#yandex_map_item_view');
    if(yandexMapItemView.length){
        var image = window.location.origin + '/' + siteFolder + '/assets/images/map-marker.png';
        var uluru = [ Number(yandexMapItemView.data('lat')), Number(yandexMapItemView.data('lng'))];

        myMap = new ymaps.Map("yandex_map_item_view", {
            center: uluru,
            controls: ['fullscreenControl', 'typeSelector', 'zoomControl'],
            zoom: 15
        });

        var myPlacemark = new ymaps.Placemark(uluru, {},
            {
                iconLayout: 'default#image',
                iconImageHref: image,
                iconImageSize: [40, 49],
                iconImageOffset: [-20, -25]
            });

        myMap.geoObjects.add(myPlacemark);
    }
}

function ymapsPanorama() {
    var yandexMapItemView = $('#yandex_map_item_view');
    var image = window.location.origin + '/' + siteFolder + '/assets/images/map-marker.png';
    var uluru = [ Number(yandexMapItemView.data('lat')), Number(yandexMapItemView.data('lng'))];

    if(myMap){
        myMap.destroy();
        myMap = null;
    }
    if(myMapPanorama){
        myMapPanorama.destroy();
        myMapPanorama = null;
    }

    myMapPanorama = new ymaps.Map('yandex_map_item_view', {
        center: uluru,
        zoom: 18,
        type: 'yandex#map',
        controls: ['typeSelector']
    });
    // Создаём коллекцию, в которой будем хранить точки на карте.
    collection = new ymaps.GeoObjectCollection();
    // Добавляем коллекцию на карту.
    myMapPanorama.geoObjects.add(collection);

    var myPlacemark = new ymaps.Placemark(uluru, {}, {
            iconLayout: 'default#image',
            iconImageHref: image,
            iconImageSize: [40, 49],
            iconImageOffset: [-20, -25]
        });

    myMapPanorama.geoObjects.add(myPlacemark);

    // Получим менеджер панорамы карты.
    myMapPanorama.getPanoramaManager().then(function (manager) {
        // Включаем режим поиска панорам на карте.
        manager.enableLookup();
        // Открываем плеер панорам.
        manager.openPlayer(myMapPanorama.getCenter());
        // Подпишемся на событие открытия плеера панорам.
        manager.events.add('openplayer', function () {
            // Получим текущий плеер панорам.
            var player = manager.getPlayer({
                closeControl : [0, -50]
            });
            // При закрытии плеера или смене панорамы удаляем добавленные точки.
            player.events.add(['closeControl', 'destroy'], function () {
                $('.item-street-view-btn').removeClass('active');
                initYandexMap();
            });
            player.events.add(options.controls);

        });
    });
}